const REGEX = /\S+/g;

/**
 * Splits up a string into words.
 * @param {string} str
 * @return {array<string>} words
 * @example
 * import {qw} from 'js-utils';
 * qw('aaa bbb ccc ddd'); // ['aaa', 'bbb', 'ccc', 'ddd']
 */
export function qw(str) {
	return str.match(REGEX) || [];
}

/**
 * Splits up a string into words and uses them to build an object.
 * @param {string} str
 * @return {object} object
 * @throws {TypeError} if the word cound is not even
 * @example
 * import {qwm} from 'js-utils';
 * qwm(`aaa bbb
 *      ccc ddd`);
 * // {'aaa': 'bbb',
 * //  'ccc': 'ddd'}
 */
export function qwm(str) {
	const arr = qw(str);

	if (arr.length % 2 !== 0) {
		throw new TypeError('Array length is not even.');
	}

	const ret = {};
	for (let i = 0; i < arr.length; i += 2) {
		ret[arr[i]] = arr[i + 1];
	}
	return ret;
}
